import Namee91 from '../../../Media/BSD/Eonna/Eonna Namee 9.webp'
import Namee92 from '../../../Media/BSD/Eonna/Eonna Namee 9.webp'





const Namee9images =[
Namee91,Namee92
]

export default Namee9images;